/**
 * Aditi Jewelry — Shopify 2.0 Theme JS
 * Luxury editorial jewelry brand
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. Luxury Motion System — scroll reveal, stagger, reduced motion
     ========================================================================== */

  var scrollRevealObserver = null;
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function forEachNode(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function prefersReducedMotion() {
    return reduceMotionQuery.matches;
  }

  function addMotionClass(selector, className, scope) {
    forEachNode((scope || document).querySelectorAll(selector), function (node) {
      if (node.closest('[data-nav], [data-nav-mobile]')) return;
      node.classList.add(className);
      node.setAttribute('data-adn-motion-auto', 'true');
    });
  }

  function setStagger(selector, scope) {
    forEachNode((scope || document).querySelectorAll(selector), function (group) {
      forEachNode(group.children, function (child, index) {
        if (!child.classList.contains('adn-motion-reveal') && !child.classList.contains('adn-motion-media')) return;
        child.style.setProperty('--adn-motion-delay', Math.min(index * 70, 420) + 'ms');
      });
    });
  }

  function annotateLuxuryMotion(scope) {
    scope = scope || document;

    addMotionClass([
      '.fc-header',
      '.cl-header__inner',
      '.pg-breadcrumb',
      '.pg-header',
      '.pg-filters',
      '.ch-meta__inner',
      '.milestones-intro',
      '.adn-footer-newsletter-inner',
      '.adn-footer-content-inner',
      '.adn-footer-bottom',
      '.page-content',
      '.blog-breadcrumbs__inner',
      '.blog-listing__header',
      '.article-breadcrumbs__inner',
      '.article-page__header',
      '.search-page__header',
      '.cart-main__heading',
      '.customer-auth__inner',
      '.customer-account__header'
    ].join(','), 'adn-motion-reveal', scope);

    addMotionClass([
      '.ch-hero__content > *',
      '.milestones-hero__inner > *',
      '.story-page__hero > div:first-child',
      '.abt-teaser__content',
      '.contact-page .bg-grain > div',
      '.pdp-breadcrumbs',
      '.pdp-info',
      '.milestone-card__copy',
      '.story-founder-grid > div:nth-child(2)',
      '.story-about-grid > div',
      '.story-about-milestones > div',
      '.story-values-grid > div',
      '.article-page__body',
      '.cart-main__empty',
      '.cart-main__summary',
      '.customer-account__details',
      '.customer-account__orders'
    ].join(','), 'adn-motion-reveal', scope);

    addMotionClass([
      '.abt-teaser__media',
      '.contact-page > div:first-child',
      '.fc-hero-link',
      '.fc-card',
      '.cl-card',
      '.pc-card',
      '.pdp-gallery',
      '.story-founder-grid > div:first-child',
      '.story-process-grid > div',
      '.story-press__item',
      '.milestone-card',
      '.blog-card',
      '.search-result',
      '.article-page__image-wrap',
      '.cart-main__item'
    ].join(','), 'adn-motion-media', scope);

    addMotionClass('.story-about-grid > div:nth-child(2), .pdp-info', 'adn-motion-reveal--right', scope);
    addMotionClass('.story-founder-grid > div:nth-child(2), .abt-teaser__content', 'adn-motion-reveal--left', scope);

    [
      '.fc-grid',
      '.fc-stack',
      '.cl-grid__inner',
      '.pg-grid',
      '.story-process-grid',
      '.story-values-grid',
      '.story-about-milestones',
      '.milestones-archive',
      '.story-press__grid',
      '.pdp-gallery__thumbs',
      '.blog-listing__grid',
      '.search-page__results',
      '.cart-main__items',
      '.customer-account__grid'
    ].forEach(function (selector) {
      setStagger(selector, scope);
    });
  }

  function isInInitialViewport(node) {
    var rect = node.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight * 0.92 && rect.bottom > 0;
  }

  function applyReducedMotion() {
    document.documentElement.classList.add('adn-reduced-motion');
    forEachNode(document.querySelectorAll('.sr, .sr-left, .sr-right, .sr-scale, .sr-stagger, .adn-motion-reveal, .adn-motion-media'), function (el) {
      el.classList.add('is-visible');
      el.classList.add('visible');
      el.style.transition = 'none';
      el.style.animation = 'none';
    });

    forEachNode(document.querySelectorAll('[style*="transition"], [style*="animation"]'), function (el) {
      el.style.transition = 'none';
      el.style.animation = 'none';
    });

    forEachNode(document.querySelectorAll('video[autoplay]'), function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  function initScrollReveal(scope) {
    scope = scope || document;
    if (scrollRevealObserver) {
      scrollRevealObserver.disconnect();
      scrollRevealObserver = null;
    }

    document.documentElement.classList.remove('adn-motion-ready');
    forEachNode(scope.querySelectorAll('.sr, .sr-left, .sr-right, .sr-scale, .sr-stagger, .adn-motion-reveal, .adn-motion-media'), function (target) {
      target.classList.add('is-visible');
      target.classList.add('visible');
      target.style.removeProperty('--adn-motion-delay');
    });
  }

  /* ==========================================================================
     2. Navbar Scroll Behavior (transparent -> dark)
     ========================================================================== */

  function initNavbar() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var isHome = document.body.classList.contains('template-index');
    var scrollThreshold = 80;

    function updateNav() {
      var scrollY = window.scrollY || window.pageYOffset;

      if (isHome) {
        if (scrollY > scrollThreshold) {
          header.classList.add('site-header--scrolled');
          header.classList.remove('site-header--transparent');
        } else {
          header.classList.remove('site-header--scrolled');
          header.classList.add('site-header--transparent');
        }
      }
    }

    // Set initial state
    if (isHome) {
      header.classList.add('site-header--transparent');
    } else {
      header.classList.add('site-header--opaque');
    }

    // Throttled scroll handler
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateNav();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateNav();
  }

  /* ==========================================================================
     3. Hero Video Parallax
     ========================================================================== */

  function initHeroParallax() {
    var heroMedia = document.querySelector('.hero-media');
    if (!heroMedia) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var mediaElement = heroMedia.querySelector('video, img');
    if (!mediaElement) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.scrollY || window.pageYOffset;
      var windowHeight = window.innerHeight;

      // Only apply parallax in the hero viewport
      if (scrollY < windowHeight * 1.2) {
        var translateY = scrollY * 0.3;
        var scale = 1 + scrollY * 0.0002;
        mediaElement.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ==========================================================================
     4. Category Filter with Grid Animation (shop-all page)
     ========================================================================== */

  function initCategoryFilter() {
    var filterContainer = document.querySelector('.category-filters');
    if (!filterContainer) return;

    var buttons = filterContainer.querySelectorAll('.category-filter-btn');
    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    var items = grid.querySelectorAll('.product-grid-item');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var category = this.getAttribute('data-category');

        // Update active state
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Animate grid items
        animateGridFilter(items, category);
      });
    });
  }

  function animateGridFilter(items, category) {
    var delay = 0;
    var staggerMs = 50;

    items.forEach(function (item) {
      var itemCategory = item.getAttribute('data-category');
      var shouldShow = category === 'all' || itemCategory === category;

      if (shouldShow) {
        // Show item with staggered delay
        setTimeout(function () {
          item.classList.remove('is-hidden');
          item.classList.add('is-visible');
          item.style.display = '';
        }, delay);
        delay += staggerMs;
      } else {
        // Hide item
        item.classList.add('is-hidden');
        item.classList.remove('is-visible');
        // After transition, set display none for layout
        setTimeout(function () {
          if (item.classList.contains('is-hidden')) {
            item.style.display = 'none';
          }
        }, 500);
      }
    });
  }

  /* ==========================================================================
     5. Mobile Menu Toggle with Staggered Animation
     ========================================================================== */

  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    if (!toggle || !menu) return;

    var isOpen = false;

    toggle.addEventListener('click', function () {
      isOpen = !isOpen;

      if (isOpen) {
        menu.classList.add('is-open');
        toggle.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else {
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    // Close on link click
    var menuLinks = menu.querySelectorAll('a');
    menuLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        isOpen = false;
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        isOpen = false;
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ==========================================================================
     6. Smooth scroll for anchor links
     ========================================================================== */

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.site-header')
            ? document.querySelector('.site-header').offsetHeight
            : 0;
          var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* ==========================================================================
     7. Lazy loading fallback for older browsers
     ========================================================================== */

  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return; // native support

    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if (!lazyImages.length) return;

    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(function (img) {
      imageObserver.observe(img);
    });
  }

  /* ==========================================================================
     8. Milestones navigation cache guard
     ========================================================================== */

  function initMilestonesNavCacheGuard() {
    var milestonesPath = '/pages/milestones';
    var freshMilestonesUrl = milestonesPath + '?view=milestones';
    var isMilestonesPage = window.location.pathname === milestonesPath;
    var hasFreshMilestonesLayout = !!document.querySelector('.milestones-feature');
    var currentParams = new URLSearchParams(window.location.search);

    if (isMilestonesPage && !hasFreshMilestonesLayout && currentParams.get('view') !== 'milestones') {
      window.location.replace(freshMilestonesUrl);
      return;
    }

    function linkExists(container) {
      return !!container.querySelector('a[href*="/pages/milestones"], a[href*="/pages/achievements"]');
    }

    function findStoryLink(container) {
      var links = Array.prototype.slice.call(container.querySelectorAll('a'));
      return links.find(function (link) {
        return link.href.indexOf('/pages/our-story') !== -1 || link.textContent.trim().toLowerCase() === 'our story';
      });
    }

    var desktopNav = document.querySelector('.adn-nav-links');
    if (desktopNav && !linkExists(desktopNav)) {
      var storyLink = findStoryLink(desktopNav);
      var desktopWrapper = document.createElement('div');
      desktopWrapper.style.position = 'relative';
      desktopWrapper.innerHTML = '<a href="' + freshMilestonesUrl + '" class="adn-nav-link" style="position:relative; font-size:13px; font-weight:400; letter-spacing:0.2em; text-transform:uppercase; color:rgba(255,255,255,0.4); text-decoration:none; transition:color 0.5s ease;">Milestones</a>';

      if (storyLink && storyLink.parentElement) {
        storyLink.parentElement.insertAdjacentElement('afterend', desktopWrapper);
      } else {
        desktopNav.appendChild(desktopWrapper);
      }
    }

    var mobileNav = document.querySelector('.adn-mobile-nav');
    if (mobileNav && !linkExists(mobileNav)) {
      var mobileStoryLink = findStoryLink(mobileNav);
      var mobileLink = document.createElement('a');
      mobileLink.href = freshMilestonesUrl;
      mobileLink.className = 'adn-mobile-link';
      mobileLink.textContent = 'Milestones';
      mobileLink.style.cssText = 'display:block; font-family:var(--font-heading); font-size:clamp(2.5rem,10vw,5rem); font-weight:300; line-height:1.15; color:rgba(255,255,255,0.7); text-decoration:none; opacity:0; transform:translateY(20px);';

      if (mobileStoryLink) {
        mobileStoryLink.insertAdjacentElement('afterend', mobileLink);
      } else {
        mobileNav.appendChild(mobileLink);
      }
    }
  }

  /* ==========================================================================
     9. Initialize All
     ========================================================================== */

  function init() {
    initScrollReveal();
    initNavbar();
    initCategoryFilter();
    initMobileMenu();
    initSmoothScroll();
    initLazyLoad();
    initMilestonesNavCacheGuard();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init scroll reveal on Shopify section re-render
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initCategoryFilter();
  });

})();
